import { useDispatch, useSelector } from 'react-redux';
import { State } from '../store/interfaces';
import { sideMenuExpandedAction } from '../store/reducers/ui-data';

export const useUIData = () => {
  const uiState = useSelector((state: State) => state.uiData);
  const dispatch = useDispatch();
  const changeSideMenuExpandedStatus = (expanded: boolean) => {
    dispatch(sideMenuExpandedAction(expanded));
  };
  return { ...uiState, changeSideMenuExpandedStatus };
};
